import apiProxy from "@shared/utils/api-proxy.ts";
import {
  EntirePeriodGroupByResult,
  FetchUsageResponse,
  PartitionGroupByResult,
  UsageGroupByType,
  UsageType,
} from "@shared/types/localTypes/usage-explorer.ts";
import { GranularityType } from "@shared/types/localTypes/common.ts";

export type {
  EntirePeriodGroupByResult,
  PartitionGroupByResult,
  FetchUsageResponse,
};

export interface FetchUsageRequest {
  nonce: string;
  start_date: string;
  end_date: string;
  subscription: number;
  filter_by?: Partial<Record<UsageGroupByType, string[]>>;
  partition_by: GranularityType;
  period_group_limit: number;
  partition_group_limit: number;
}

export default async ({
  request,
  usageType,
}: {
  request: FetchUsageRequest;
  usageType: UsageType;
}) => {
  const response: FetchUsageResponse | null = await apiProxy.post(
    `usage-explorer/get-usage/${usageType}`,
    request,
  );

  if (!response) {
    throw new Error("Got no response from server");
  }
  return response;
};
